// Computer Vision — xizmat sahifasi kontenti (uz / ru)
// SEO: "computer vision", "kompyuter ko'rish", "video tahlil", "yuzni aniqlash",
// "avtomobil raqamini tanish", "mahsulot sanog'i", "sifat nazorati", "narx".

const uz = {
    meta: {
        title: "Computer Vision joriy etish — narxi 45 mln so'mdan",
        description:
            "Computer Vision — kamera tasviri va videoni avtomatik tahlil qilish: yuzni aniqlash, avtomobil raqamini tanish, mahsulot sanog'i, xavfsizlik va sifat nazorati. Narx 45 mln so'mdan, muddat 6–14 hafta.",
        keywords: [
            "computer vision",
            "kompyuter ko'rish",
            "video tahlil",
            "yuzni aniqlash",
            "avtomobil raqamini tanish",
            "mahsulot sanog'i",
            "sifat nazorati",
            "sun'iy intellekt",
            "YOLO",
            "computer vision narxi",
        ],
    },

    hero: {
        eyebrow: "Computer Vision / Kompyuter ko'rish",
        h1: "Computer Vision joriy etish — 45 mln so'mdan",
        lead:
            "Kameralaringiz allaqachon ishlayapti, lekin yozuvni faqat hodisa bo'lgandan keyin ko'rasiz. Computer Vision shu oqimni real vaqtda o'qiydi: odamni, mahsulotni, avtomobil raqamini va qoidabuzarlikni o'zi topib, sizga xabar beradi.",
        ctaPrimary: "Bepul konsultatsiya olish",
        ctaSecondary: "Narxlarni ko'rish",
        proof: [
            "Mavjud IP-kameralar bilan ishlaydi",
            "Edge qurilmada — internetsiz ham",
            "Pilot 6–8 haftada ishga tushadi",
            "Aniqlik o'lchanadi va hujjatlashtiriladi",
        ],
    },

    intro: {
        h: "Computer Vision nima va u qanday masalalarni yechadi?",
        p: [
            "Computer Vision — kompyuterga tasvir va videoni «ko'rish» imkonini beradigan yo'nalish. Model kadrdagi obyektlarni topadi, ularni sinflarga ajratadi va harakatini kuzatadi. Natijada kamera oddiy yozuvchi qurilmadan o'lchov asbobiga aylanadi: u nafaqat yozadi, balki sanaydi, taqqoslaydi va ogohlantiradi.",
            "Amalda bu juda oddiy savollarga javob berish demakdir. Kassa oldida hozir necha kishi turibdi? Omborda qutilar soni hujjatdagiga to'g'ri keladimi? Qurilish maydoniga kaskasiz kirgan odam bormi? Shlagbaumga kelgan avtomobil ruxsat etilganlar ro'yxatidami? Konveyerdan o'tgan mahsulotda nuqson bormi? Ilgari bu savollarga odam qarab javob berardi — endi dastur javob beradi, odam esa faqat chetlanishlarni tekshiradi.",
            "Innobek bu ishni realistik boshlaydi. Avval bitta aniq masalani tanlaymiz va uni pilot ko'rinishida ishga tushiramiz, keyin miqyosni kengaytiramiz. Chunki Computer Vision loyihasining qiymati modelda emas — ma'lumot yig'ishda, kamera burchagini to'g'ri qo'yishda va natijani sizning jarayoningizga ulashda. Model tayyor bo'lgani bilan, agar u hech kimga xabar yubormasa, foyda keltirmaydi.",
            "Texnik tomondan biz sinovdan o'tgan vositalarni ishlatamiz: obyekt aniqlash uchun YOLO oilasidagi modellar, kadr bilan ishlash uchun OpenCV, o'qitish uchun PyTorch. Tayyor model ONNX yoki TensorRT formatiga o'tkaziladi — bu tezlikni bir necha barobar oshiradi. Kamera bilan aloqa standart RTSP oqimi orqali, hisoblash esa serverda yoki NVIDIA Jetson kabi edge qurilmada bajariladi. Qaysi variant sizga mosligini kameralar soni, kerakli tezlik va internet sifati hal qiladi.",
        ],
    },

    definition: {
        term: "Computer Vision nima?",
        text:
            "Computer Vision — sun'iy intellekt yordamida kamera tasviri va videosini avtomatik tahlil qilib, undagi obyektlarni, odamlarni, matnni va hodisalarni aniqlaydigan texnologiya. U kamera oqimidan o'lchanadigan ma'lumot — son, holat va ogohlantirish — chiqaradi.",
    },

    included: {
        eyebrow: "Nimalar kiradi",
        h: "Har bir loyihaga standart tarzda kiradi",
        sub: "Bular alohida to'lanadigan qo'shimcha emas — bazaviy tarifda ham bor.",
        items: [
            "Bepul konsultatsiya va masalaning texnik amalga oshirilishi tahlili",
            "Mavjud kameralarni tekshirish: burchak, yoritish, ruxsat va FPS",
            "Video ma'lumot yig'ish va uni belgilash (annotatsiya)",
            "Model tanlash va sizning sharoitingizda qayta o'qitish",
            "Aniqlikni o'lchash: precision, recall va xato turlari bo'yicha hisobot",
            "RTSP oqimini uzluksiz o'qiydigan servis",
            "Hodisalar jurnali va kadr-dalil bilan arxiv",
            "Telegram yoki elektron pochta orqali ogohlantirish",
            "Veb-panel: jonli ko'rinish, filtr va statistika",
            "Mavjud tizimingizga (CRM, ERP, 1C, ombor) API orqali ulash",
            "Xodimlar uchun qo'llanma va ishga o'rgatish sessiyasi",
            "Ishga tushgandan keyin 6 oylik texnik qo'llab-quvvatlash",
        ],
    },

    benefits: {
        eyebrow: "Nega kerak",
        h: "Computer Vision biznesga nima beradi?",
        sub: "Kamera odamni almashtirmaydi — u odamga nimaga qarash kerakligini ko'rsatadi.",
        items: [
            {
                t: "Uzluksiz nazorat",
                d: "Operator 8 soatdan keyin charchaydi va 20 ta ekranni bir vaqtda kuzata olmaydi. Model 24/7 bir xil diqqat bilan ishlaydi va faqat shubhali kadrni odamga uzatadi.",
            },
            {
                t: "Raqamlar paydo bo'ladi",
                d: "Navbat uzunligi, do'kondagi odam oqimi, ombordagi qoldiq, konveyerdagi nuqson foizi — bularning hammasi kunlik grafikka aylanadi va qaror qabul qilish uchun asos bo'ladi.",
            },
            {
                t: "Hodisaga darhol javob",
                d: "Kaskasiz ishchi yoki taqiqlangan zonaga kirish aniqlangan zahoti Telegram'ga kadr bilan xabar ketadi. Yozuvni ertasi kuni ko'rish bilan buni taqqoslab bo'lmaydi.",
            },
            {
                t: "Qo'lda sanash tugaydi",
                d: "Inventarizatsiya va kirim-chiqimni qo'lda sanash uzoq va xatoga moyil. Model qutilarni bir necha soniyada sanaydi va natijani ombor tizimiga yozadi.",
            },
            {
                t: "Kirish nazorati tezlashadi",
                d: "Avtomobil raqamini tanish shlagbaumni 1–2 soniyada ochadi, yuzni aniqlash esa xodim kartasiz o'tishini ta'minlaydi. Qorovul har mashinani qo'lda qayd etmaydi.",
            },
            {
                t: "Mavjud uskuna ishlatiladi",
                d: "Ko'p holatda yangi kamera sotib olish shart emas: sifatli IP-kamera bo'lsa, RTSP oqimidan foydalanamiz. Faqat burchak yoki yoritishni tuzatish kerak bo'lishi mumkin.",
            },
            {
                t: "Bahs-munozara tugaydi",
                d: "Har bir hodisa kadr bilan saqlanadi. Ombordagi kamomad yoki xavfsizlik qoidasining buzilishi bo'yicha «men qilmadim» degan bahs o'rniga aniq vaqt va tasvir turadi.",
            },
            {
                t: "Jarayon o'zi tuzatiladi",
                d: "Model natijasi CRM yoki ERP'ga tushganda, keyingi qadam avtomatik ishga tushadi: qoldiq kamaysa buyurtma shakllanadi, nuqson chiqsa liniya to'xtatiladi.",
            },
        ],
    },

    audience: {
        eyebrow: "Qayerda qo'llaniladi",
        h: "Real qo'llanish misollari",
        sub: "Quyidagi stsenariylar bugun O'zbekiston sharoitida amalda ishlaydi.",
        items: [
            {
                t: "Do'konda navbat tahlili",
                d: "Kassa oldidagi odamlar soni sanaladi. Navbat 5 kishidan oshsa — administratorga xabar. Kunlik grafik qaysi soatda qo'shimcha kassir kerakligini ko'rsatadi.",
            },
            {
                t: "Omborda mahsulot sanog'i",
                d: "Palletadagi qutilar, javondagi birliklar va yuk mashinasiga ortilgan hajm kadrdan sanaladi. Natija ombor tizimidagi hujjat bilan solishtiriladi, farq chiqsa ogohlantirish beriladi.",
            },
            {
                t: "Qurilishda xavfsizlik kaskasi nazorati",
                d: "Model kaskasi va signal juba yo'q ishchini aniqlaydi, kadrni saqlaydi va xavfsizlik muhandisiga yuboradi. Taqiqlangan zonaga kirishni ham shu tarzda qayd etish mumkin.",
            },
            {
                t: "Avtoturargohda raqam tanish",
                d: "Kirish va chiqishdagi kamera davlat raqamini o'qiydi, turish vaqtini hisoblaydi va to'lovni belgilaydi. Ruxsat etilgan ro'yxatdagi mashina uchun shlagbaum o'zi ochiladi.",
            },
            {
                t: "Ishlab chiqarishda sifat nazorati",
                d: "Konveyerdagi mahsulot yuzasidagi tirnalish, yorilish, noto'g'ri yorliq yoki yetishmayotgan qism aniqlanadi. Nuqsonli birlik belgilanadi va smena bo'yicha statistika yig'iladi.",
            },
            {
                t: "Klinikada tasvir tahlili",
                d: "Rentgen va boshqa tasvirlarda shubhali sohalarni ajratib ko'rsatuvchi yordamchi modul. Bu tashxis emas — bu shifokor diqqatini yo'naltiradigan vosita, yakuniy qaror har doim shifokorniki.",
            },
            {
                t: "Restoran va oshxonada gigiyena",
                d: "Ish kiyimi, qo'lqop va bosh kiyim mavjudligi tekshiriladi, tozalash jadvalining bajarilishi qayd etiladi. Tekshiruv kelganda bu hujjatlashtirilgan dalil bo'lib xizmat qiladi.",
            },
        ],
    },

    pricing: {
        eyebrow: "Narxlar",
        h: "Computer Vision narxi — 3 ta tarif",
        sub: "Narxlar bir martalik ishlanma uchun. Har bir tarifga ma'lumot yig'ish, model o'qitish va aniqlik hisoboti kiradi.",
        note:
            "Narxlar 2026-yil uchun ko'rsatilgan va yakuniy hisob-kitob bepul tahlildan keyin tasdiqlanadi. Narxga kamera, server yoki edge qurilma (masalan NVIDIA Jetson) qiymati kirmaydi — ularni o'zingiz sotib olasiz yoki biz spetsifikatsiya beramiz. Bulut serveri va internet aloqasi to'lovi ham alohida.",
        tiers: [
            {
                name: "Pilot",
                tagline: "Bitta masala, 1–3 kamera",
                price: "45 000 000",
                priceNote: "so'mdan",
                term: "6–8 hafta",
                best: "Texnologiya sizning sharoitingizda ishlashini katta byudjetsiz tekshirish",
                features: [
                    "Bitta aniq masala: sanash, kaskа nazorati yoki raqam tanish",
                    "1–3 ta kamera oqimini qayta ishlash",
                    "Video yig'ish va 2 000–5 000 kadrni belgilash",
                    "YOLO asosidagi modelni sizning ma'lumotingizda o'qitish",
                    "Aniqlik hisoboti: precision, recall va xato misollari",
                    "Telegram orqali ogohlantirish va kadr-dalil",
                    "Hodisalar jurnali bo'lgan oddiy veb-panel",
                    "Bitta server yoki edge qurilmaga o'rnatish",
                    "Xodimlarni o'rgatish (1 sessiya)",
                    "6 oylik texnik qo'llab-quvvatlash",
                ],
            },
            {
                name: "Standart",
                tagline: "Obyekt bo'ylab to'liq joriy etish",
                price: "120 000 000",
                priceNote: "so'mdan",
                term: "10–14 hafta",
                featured: true,
                best: "Pilot natija bergan va uni butun obyektga yoyish kerak bo'lgan holat",
                features: [
                    "Barcha Pilot imkoniyatlari",
                    "4–16 ta kamera va bir nechta stsenariy bir vaqtda",
                    "Kengaytirilgan ma'lumot to'plami va modelni qayta o'qitish sikli",
                    "Obyektni kuzatish (tracking) va zonalar bo'yicha qoidalar",
                    "Analitika paneli: soat, smena va zona kesimida grafiklar",
                    "CRM, ERP, 1C yoki ombor tizimi bilan API integratsiya",
                    "Rollar va ruxsatlar tizimi, audit jurnali",
                    "Edge qurilmada ishlash — internet uzilsa ham to'xtamaydi",
                    "Kamera joylashuvi va yoritish bo'yicha tavsiyalar",
                    "Yuklamaga chidamlilik testi va monitoring",
                    "6 oylik texnik qo'llab-quvvatlash",
                ],
            },
            {
                name: "Enterprise",
                tagline: "Bir nechta obyekt va individual model",
                price: "Kelishuv",
                priceNote: "asosida",
                term: "Loyihaga qarab",
                best: "Filiallar tarmog'i, yuqori yuklama yoki nostandart sifat nazorati",
                features: [
                    "Bir nechta obyekt va markazlashtirilgan boshqaruv",
                    "16 tadan ortiq kamera, gorizontal masshtablash",
                    "Nostandart masala uchun individual model arxitekturasi",
                    "Yopiq kontur: barcha ma'lumot sizning serveringizda qoladi",
                    "Modelni muntazam qayta o'qitish va sifat monitoringi (MLOps)",
                    "Shaxsiy ma'lumotlarni himoyalash bo'yicha siyosat va anonimlashtirish",
                    "SLA va ustuvor qo'llab-quvvatlash",
                    "Ichki jamoangizni o'qitish va hujjatlarni topshirish",
                ],
            },
        ],
    },

    process: {
        eyebrow: "Jarayon",
        h: "Computer Vision qanday joriy etiladi",
        sub: "Olti bosqich. Loyihaning muvaffaqiyati modelga emas, ma'lumot sifatiga bog'liq.",
        steps: [
            {
                t: "Masalani aniqlash",
                time: "3–7 kun",
                d: "Nimani o'lchashimiz kerakligini bitta gapda yozamiz va muvaffaqiyat mezonini kelishamiz: qanday aniqlikda va qanday tezlikda.",
            },
            {
                t: "Kamera auditi",
                time: "3–5 kun",
                d: "Mavjud kameralarning burchagi, ruxsati, yoritilishi va RTSP oqimi tekshiriladi. Kerak bo'lsa joylashuvni o'zgartirish tavsiya qilinadi.",
            },
            {
                t: "Ma'lumot yig'ish va belgilash",
                time: "2–3 hafta",
                d: "Sizning obyektingizdan video yig'iladi va kadrlar qo'lda belgilanadi. Bu bosqich eng ko'p vaqt oladi, lekin aniqlikni aynan u belgilaydi.",
            },
            {
                t: "Model o'qitish",
                time: "1–3 hafta",
                d: "YOLO oilasidagi model PyTorch'da o'qitiladi, so'ng ONNX yoki TensorRT formatiga o'tkazilib tezlashtiriladi. Natija test to'plamida o'lchanadi.",
            },
            {
                t: "Integratsiya va o'rnatish",
                time: "2–4 hafta",
                d: "Servis serverga yoki Jetson kabi edge qurilmaga o'rnatiladi, ogohlantirish kanallari va sizning tizimingiz bilan API ulanadi.",
            },
            {
                t: "Sinov va sozlash",
                time: "davomiy",
                d: "Birinchi 3–4 hafta real sharoitda kuzatamiz: yolg'on ishga tushishlarni kamaytiramiz, chegaralarni sozlaymiz va modelni yangi kadrlarda qayta o'qitamiz.",
            },
        ],
    },

    samples: {
        eyebrow: "Namunalar",
        h: "Biz ishlagan loyihalar",
        sub: "Ishlab chiqarish, logistika va xavfsizlik sohasidagi tizimlar — jarayon tahlilidan ishga tushirishgacha.",
        cta: "Barcha loyihalar",
        slugs: ["firewise", "suvmash-jsc", "logistatrans", "grandpharm"],
    },

    faq: {
        eyebrow: "Savol-javob",
        h: "Ko'p beriladigan savollar",
        sub: "Computer Vision bo'yicha eng ko'p so'raladigan savollarga qisqa javoblar.",
        items: [
            {
                q: "Computer Vision joriy etish qancha turadi?",
                a: "Pilot loyiha 45 000 000 so'mdan boshlanadi: bu bitta masala va 1–3 kamera uchun to'liq ishlaydigan yechim. Obyekt bo'ylab to'liq joriy etish, ya'ni 4–16 kamera va bir nechta stsenariy, 120 000 000 so'mdan. Filiallar tarmog'i yoki nostandart model kerak bo'lsa, narx kelishuv asosida belgilanadi. Kamera va server qiymati narxga kirmaydi.",
            },
            {
                q: "Aniqlik necha foiz bo'ladi?",
                a: "100% aniqlik bo'lmaydi va buni va'da qiladigan taklifga ishonmang. Yaxshi yoritilgan, to'g'ri burchakdagi kamerada raqam tanish va obyekt sanash odatda 90–97% oralig'ida ishlaydi. Murakkab sharoitda — qorong'ilik, yomg'ir, obyektlar bir-birini to'sganda — bu 75–90% gacha tushadi. Aniq raqamni pilotdan keyin test to'plamida o'lchab beramiz.",
            },
            {
                q: "Mavjud kameralarim ishlatiladimi?",
                a: "Ko'pincha ha. Kamera RTSP oqimini bersa va ruxsati kamida 1080p bo'lsa, uni ishlatamiz. Muammo odatda kamerada emas, uning burchagida: yuqoridan tik qaragan kamera yuzni ko'rsatmaydi, juda uzoqdagi kamera esa mahsulot yorlig'ini o'qiy olmaydi. Audit bosqichida buni aniqlab, aniq tavsiya beramiz.",
            },
            {
                q: "Loyiha qancha vaqt oladi?",
                a: "Pilot 6–8 haftada ishga tushadi, obyekt bo'ylab to'liq joriy etish 10–14 hafta oladi. Muddatning katta qismi ma'lumot yig'ish va belgilashga ketadi — bu ishni tezlashtirib bo'lmaydi, chunki model faqat ko'rgan holatlarni taniydi. Agar sizda arxiv video bo'lsa, muddat 1–2 haftaga qisqarishi mumkin.",
            },
            {
                q: "Internet uzilib qolsa, tizim ishlaydimi?",
                a: "Ha, agar yechim edge qurilmada ishlasa. NVIDIA Jetson kabi qurilma kamera yonida turadi va tahlilni joyning o'zida bajaradi, internet esa faqat xabar yuborish uchun kerak bo'ladi. Aloqa uzilganda hodisalar mahalliy bazada saqlanadi va internet tiklanganda serverga yuboriladi. Bu yondashuv uzoq obyektlar — qurilish maydoni, karyer, yo'l chetidagi ombor uchun ayniqsa qulay, chunki u barqaror kanalga bog'liq emas.",
            },
            {
                q: "Video ma'lumotlar qayerda saqlanadi?",
                a: "Buni siz tanlaysiz. Standart yondashuvda butun video saqlanmaydi — faqat hodisa kadri va raqamli natija yoziladi, bu joyni ham, xavfni ham kamaytiradi. Yopiq kontur talab qilinsa, butun tizim sizning serveringizda ishlaydi va hech qanday kadr tashqariga chiqmaydi. Yuzlarni avtomatik xiralashtirish ham qo'shilishi mumkin.",
            },
            {
                q: "Yuzni aniqlash qanchalik ishonchli?",
                a: "Yaxshi yoritilgan, yuz kameraga qaragan sharoitda xodimlarni tanish 95% dan yuqori ishlaydi. Lekin niqob, quyosh ko'zoynagi, yon burchak va qorong'ilik natijani sezilarli pasaytiradi. Shuning uchun yuzni aniqlashni kirish nazoratida yagona usul sifatida emas, karta yoki PIN bilan birga ishlatishni tavsiya qilamiz.",
            },
            {
                q: "Bitta serverga nechta kamera ulash mumkin?",
                a: "Bu modelga va kerakli tezlikka bog'liq. O'rtacha GPU serveri 8–16 kamerani sekundiga 5–10 kadr tezlikda qayta ishlay oladi — sanash va xavfsizlik nazorati uchun bu yetarli. Konveyerdagi tez harakat uchun esa kamera boshiga ancha ko'proq resurs kerak bo'ladi. Aniq spetsifikatsiyani masalangizni va kerakli kadr tezligini bilganimizdan keyin, ortiqcha xarid qilmaslik uchun hisoblab beramiz.",
            },
            {
                q: "Model vaqt o'tishi bilan yomonlashadimi?",
                a: "Ha, agar sharoit o'zgarsa. Yangi qadoq turi, kamera burchagining siljishi, fasl bo'yicha yoritish o'zgarishi — bularning hammasi aniqlikni pasaytiradi. Shu sababli qo'llab-quvvatlash tarkibiga sifat monitoringi kiradi: xatolar to'planib boradi va model odatda yiliga bir yoki ikki marta yangi kadrlarda qayta o'qitiladi. Bu ish oldindan rejalashtiriladi.",
            },
            {
                q: "Qaysi holatda Computer Vision kerak emas?",
                a: "Agar masalani oddiyroq usul bilan yechish mumkin bo'lsa. Mahsulotda shtrix-kod bo'lsa, skaner arzonroq va aniqroq; kirish nazorati uchun karta yoki turniket yetarli bo'lishi mumkin. Shuningdek, hodisa juda kam uchraydigan va uni qo'lda tekshirish oson bo'lsa, loyiha o'zini oqlamasligi mumkin. Buni konsultatsiyada ochiq aytamiz.",
            },
        ],
    },

    cta: {
        h: "Kameralaringiz nimani ko'rsatishi kerak?",
        p: "Bepul konsultatsiyada masalangizni tahlil qilamiz, uni Computer Vision bilan yechish mumkinmi va qanday aniqlikka erishish realistik ekanini aytamiz. Telefon: +998 90 954 12 62.",
        button: "Bepul konsultatsiya olish",
        secondary: "Telegram orqali yozish",
    },

    images: [
        {
            src: "/assets/img/services/computer-vision-hero.webp",
            alt: "Computer Vision tizimi omborda qutilarni real vaqtda sanab, ekranda ramka bilan belgilamoqda",
            caption: "Kamera oqimidagi har bir obyekt ramkaga olinadi va sanab boriladi.",
            prompt: "Wide photorealistic shot of a modern warehouse aisle with stacked cardboard boxes on pallets. Overlaid on the image are clean neon-cyan bounding boxes around each box with small confidence labels like 0.94, plus a counter widget in the corner reading 'BOXES: 128'. Industrial lighting, slight depth of field, dark teal and graphite color grading, no visible faces, no text other than the overlay labels. 16:9.",
        },
        {
            src: "/assets/img/services/computer-vision-ppe.webp",
            alt: "Qurilish maydonida kaska va signal juba nazorati uchun computer vision video tahlili",
            caption: "Kaskasiz ishchi aniqlangan zahoti xavfsizlik muhandisiga kadr bilan xabar ketadi.",
            prompt: "Photorealistic construction site viewed from a fixed CCTV angle, several workers in helmets and high-visibility vests. Green bounding boxes labelled 'HELMET OK' around compliant workers and one amber box labelled 'NO HELMET' around a worker without one. Slight CCTV grain, timestamp in the top corner, muted daylight, faces blurred. 16:9.",
        },
        {
            src: "/assets/img/services/computer-vision-anpr.webp",
            alt: "Avtoturargoh kirishida avtomobil davlat raqamini tanish va shlagbaumni avtomatik ochish",
            caption: "Raqam 1–2 soniyada o'qiladi va ruxsatlar ro'yxati bilan solishtiriladi.",
            prompt: "Night scene at a parking barrier entrance, a car approaching with headlights on. A crisp cyan rectangle highlights the license plate area with a readout panel beside it showing recognised characters and a green 'ACCESS GRANTED' state. Wet asphalt reflections, cinematic dark blue palette, plate characters are generic and unreadable as a real number. 16:9.",
        },
        {
            src: "/assets/img/services/computer-vision-quality.webp",
            alt: "Ishlab chiqarish konveyerida mahsulot sifatini computer vision orqali avtomatik nazorat qilish",
            caption: "Nuqsonli birlik belgilanadi va smena bo'yicha statistikaga tushadi.",
            prompt: "Close-up of a factory conveyor belt carrying identical metal or plastic components under bright inspection lighting, with an industrial camera mounted above. Most parts are outlined in green, one is outlined in red with a small label 'DEFECT: SCRATCH'. Shallow depth of field, clean industrial aesthetic, cool white lighting, no people. 16:9.",
        },
        {
            src: "/assets/img/services/computer-vision-dashboard.webp",
            alt: "Computer Vision analitika paneli: navbat uzunligi, hodisalar jurnali va kunlik grafiklar",
            caption: "Kameradan chiqqan ma'lumot kunlik grafik va hodisalar jurnaliga aylanadi.",
            prompt: "Clean dark-themed analytics dashboard UI on a widescreen monitor: a live camera tile in the top left, a line chart of queue length by hour, a bar chart of detections per shift, and a scrollable event log with small thumbnail frames. Cyan and violet accents on a graphite background, generic placeholder labels, no real brand names, crisp UI rendering. 16:9.",
        },
    ],

    related: ["sun-iy-intellekt", "ai-integratsiya", "ai-agent", "biznes-avtomatlashtirish"],
};

const ru = {
    meta: {
        title: "Computer Vision — внедрение, цена от 45 млн сум",
        description:
            "Computer Vision — автоматический анализ изображений и видео: распознавание лиц и автономеров, подсчёт товара, контроль безопасности и качества. Цена от 45 млн сум, срок 6–14 недель.",
        keywords: [
            "computer vision",
            "компьютерное зрение",
            "видеоаналитика",
            "распознавание лиц",
            "распознавание автономеров",
            "подсчёт товара",
            "контроль качества",
            "искусственный интеллект",
            "YOLO",
            "computer vision цена",
        ],
    },

    hero: {
        eyebrow: "Computer Vision / Компьютерное зрение",
        h1: "Внедрение Computer Vision — от 45 млн сум",
        lead:
            "Камеры у вас уже работают, но запись вы смотрите только после происшествия. Computer Vision читает тот же поток в реальном времени: сам находит человека, товар, автономер или нарушение и сообщает вам об этом.",
        ctaPrimary: "Получить бесплатную консультацию",
        ctaSecondary: "Посмотреть цены",
        proof: [
            "Работает с вашими IP-камерами",
            "На edge-устройстве — даже без интернета",
            "Пилот запускается за 6–8 недель",
            "Точность измеряется и документируется",
        ],
    },

    intro: {
        h: "Что такое Computer Vision и какие задачи он решает?",
        p: [
            "Computer Vision — направление, которое даёт компьютеру способность «видеть» изображение и видео. Модель находит объекты в кадре, относит их к классам и отслеживает движение. В результате камера перестаёт быть просто регистратором и становится измерительным прибором: она не только записывает, но и считает, сравнивает и предупреждает.",
            "На практике это ответы на очень простые вопросы. Сколько человек стоит сейчас у кассы? Совпадает ли количество коробок на складе с накладной? Есть ли на площадке рабочий без каски? Числится ли подъехавший автомобиль в списке допуска? Есть ли дефект на детали, прошедшей по конвейеру? Раньше на это отвечал человек, глядя на экран, — теперь отвечает программа, а человек проверяет только отклонения.",
            "Innobek начинает такие проекты реалистично. Сначала мы берём одну конкретную задачу и запускаем её как пилот, и только потом расширяем охват. Ценность проекта по компьютерному зрению — не в самой модели, а в сборе данных, правильном ракурсе камеры и связке результата с вашим процессом. Готовая модель бесполезна, если она никому не отправляет уведомление.",
            "Технически мы используем проверенный набор инструментов: модели семейства YOLO для детекции объектов, OpenCV для работы с кадром, PyTorch для обучения. Готовая модель переводится в ONNX или TensorRT — это ускоряет её в несколько раз. Связь с камерами идёт по стандартному RTSP-потоку, а вычисления выполняются на сервере или на edge-устройстве вроде NVIDIA Jetson. Что подойдёт именно вам, зависит от числа камер, нужной скорости и качества интернета.",
        ],
    },

    definition: {
        term: "Что такое Computer Vision?",
        text:
            "Computer Vision — технология, которая с помощью искусственного интеллекта автоматически анализирует изображения и видео с камер и распознаёт объекты, людей, текст и события. Из видеопотока она получает измеримые данные — числа, статусы и оповещения.",
    },

    included: {
        eyebrow: "Что входит",
        h: "Что входит в каждый проект по умолчанию",
        sub: "Это не платные опции — они есть и в базовом тарифе.",
        items: [
            "Бесплатная консультация и оценка технической выполнимости задачи",
            "Проверка существующих камер: ракурс, освещение, разрешение и FPS",
            "Сбор видеоданных и их разметка (аннотация)",
            "Подбор модели и дообучение под ваши условия",
            "Измерение точности: отчёт по precision, recall и типам ошибок",
            "Сервис непрерывного чтения RTSP-потока",
            "Журнал событий с кадром-доказательством",
            "Оповещения в Telegram или на электронную почту",
            "Веб-панель: живой просмотр, фильтры и статистика",
            "Интеграция по API с вашей системой (CRM, ERP, 1С, склад)",
            "Инструкция для сотрудников и обучающая сессия",
            "6 месяцев технической поддержки после запуска",
        ],
    },

    benefits: {
        eyebrow: "Зачем это нужно",
        h: "Что Computer Vision даёт бизнесу",
        sub: "Камера не заменяет человека — она показывает, куда именно ему смотреть.",
        items: [
            {
                t: "Непрерывный контроль",
                d: "Оператор устаёт через 8 часов и физически не может следить за 20 экранами сразу. Модель работает круглосуточно с одинаковым вниманием и передаёт человеку только подозрительный кадр.",
            },
            {
                t: "Появляются цифры",
                d: "Длина очереди, поток людей в зале, остаток на складе, доля брака на линии — всё это превращается в дневной график и становится основанием для решений.",
            },
            {
                t: "Мгновенная реакция на событие",
                d: "Как только замечен рабочий без каски или вход в запрещённую зону, в Telegram уходит сообщение с кадром. Просмотр записи на следующий день с этим не сравнится.",
            },
            {
                t: "Ручной подсчёт больше не нужен",
                d: "Инвентаризация и приёмка вручную занимают часы и дают ошибки. Модель считает коробки за секунды и записывает результат в складскую систему.",
            },
            {
                t: "Ускоряется контроль доступа",
                d: "Распознавание автономера открывает шлагбаум за 1–2 секунды, распознавание лица пропускает сотрудника без карты. Охраннику не нужно вручную записывать каждую машину.",
            },
            {
                t: "Используется имеющееся оборудование",
                d: "Чаще всего покупать новые камеры не нужно: если есть нормальная IP-камера, мы берём её RTSP-поток. Иногда достаточно поправить ракурс или освещение.",
            },
            {
                t: "Споры заканчиваются",
                d: "Каждое событие сохраняется вместе с кадром. При недостаче на складе или нарушении техники безопасности вместо разбирательств «я этого не делал» есть точное время и изображение.",
            },
            {
                t: "Процесс запускается сам",
                d: "Когда результат модели попадает в CRM или ERP, следующий шаг выполняется автоматически: при падении остатка формируется заказ, при обнаружении брака останавливается линия.",
            },
        ],
    },

    audience: {
        eyebrow: "Где применяется",
        h: "Реальные сценарии применения",
        sub: "Все перечисленные сценарии работают в условиях Узбекистана уже сегодня.",
        items: [
            {
                t: "Анализ очередей в магазине",
                d: "Система считает людей у касс. Если очередь больше 5 человек — уведомление администратору. Дневной график показывает, в какие часы нужен дополнительный кассир.",
            },
            {
                t: "Подсчёт товара на складе",
                d: "Коробки на паллете, единицы на полке и объём загрузки в машину считаются по кадру. Результат сверяется с документом в складской системе, при расхождении приходит оповещение.",
            },
            {
                t: "Контроль касок на стройке",
                d: "Модель находит рабочего без каски или сигнального жилета, сохраняет кадр и отправляет его инженеру по охране труда. Так же фиксируется вход в запрещённую зону.",
            },
            {
                t: "Распознавание номеров на парковке",
                d: "Камеры на въезде и выезде читают госномер, считают время стоянки и рассчитывают оплату. Для машин из списка допуска шлагбаум открывается сам.",
            },
            {
                t: "Контроль качества на производстве",
                d: "На конвейере выявляются царапины, трещины, смещённая этикетка или отсутствующая деталь. Бракованная единица помечается, по смене собирается статистика.",
            },
            {
                t: "Анализ снимков в клинике",
                d: "Вспомогательный модуль подсвечивает подозрительные участки на рентгене и других снимках. Это не диагноз, а инструмент, который направляет внимание врача: итоговое решение всегда за ним.",
            },
            {
                t: "Гигиена в ресторане и на кухне",
                d: "Проверяется наличие спецодежды, перчаток и головного убора, фиксируется выполнение графика уборки. При проверке это служит задокументированным подтверждением.",
            },
        ],
    },

    pricing: {
        eyebrow: "Цены",
        h: "Стоимость Computer Vision — 3 тарифа",
        sub: "Цены разовые, за разработку. В каждый тариф входят сбор данных, обучение модели и отчёт о точности.",
        note:
            "Цены указаны на 2026 год, итоговая смета подтверждается после бесплатного анализа. В стоимость не входят камеры, сервер и edge-устройство (например, NVIDIA Jetson) — вы покупаете их сами или мы даём спецификацию. Облачный сервер и связь оплачиваются отдельно.",
        tiers: [
            {
                name: "Пилот",
                tagline: "Одна задача, 1–3 камеры",
                price: "45 000 000",
                priceNote: "сум",
                term: "6–8 недель",
                best: "Проверить технологию в ваших условиях без большого бюджета",
                features: [
                    "Одна конкретная задача: подсчёт, контроль касок или распознавание номеров",
                    "Обработка потока с 1–3 камер",
                    "Сбор видео и разметка 2 000–5 000 кадров",
                    "Обучение модели на базе YOLO на ваших данных",
                    "Отчёт о точности: precision, recall и примеры ошибок",
                    "Оповещения в Telegram с кадром-доказательством",
                    "Простая веб-панель с журналом событий",
                    "Установка на один сервер или edge-устройство",
                    "Обучение сотрудников (1 сессия)",
                    "6 месяцев технической поддержки",
                ],
            },
            {
                name: "Стандарт",
                tagline: "Полное внедрение на объекте",
                price: "120 000 000",
                priceNote: "сум",
                term: "10–14 недель",
                featured: true,
                best: "Пилот дал результат, и его нужно развернуть на весь объект",
                features: [
                    "Все возможности тарифа «Пилот»",
                    "4–16 камер и несколько сценариев одновременно",
                    "Расширенный набор данных и цикл дообучения модели",
                    "Трекинг объектов и правила по зонам",
                    "Панель аналитики: графики по часам, сменам и зонам",
                    "Интеграция по API с CRM, ERP, 1С или складской системой",
                    "Роли, права доступа и журнал аудита",
                    "Работа на edge-устройстве — не останавливается без интернета",
                    "Рекомендации по размещению камер и освещению",
                    "Нагрузочное тестирование и мониторинг",
                    "6 месяцев технической поддержки",
                ],
            },
            {
                name: "Enterprise",
                tagline: "Несколько объектов и своя модель",
                price: "По договорённости",
                priceNote: "индивидуально",
                term: "Зависит от проекта",
                best: "Сеть филиалов, высокая нагрузка или нестандартный контроль качества",
                features: [
                    "Несколько объектов и централизованное управление",
                    "Более 16 камер, горизонтальное масштабирование",
                    "Индивидуальная архитектура модели под нестандартную задачу",
                    "Закрытый контур: все данные остаются на вашем сервере",
                    "Регулярное дообучение и мониторинг качества (MLOps)",
                    "Политика защиты персональных данных и обезличивание",
                    "SLA и приоритетная поддержка",
                    "Обучение вашей команды и передача документации",
                ],
            },
        ],
    },

    process: {
        eyebrow: "Процесс",
        h: "Как внедряется Computer Vision",
        sub: "Шесть этапов. Успех проекта зависит не от модели, а от качества данных.",
        steps: [
            {
                t: "Постановка задачи",
                time: "3–7 дней",
                d: "Формулируем в одном предложении, что именно надо измерять, и согласуем критерий успеха: какая точность и какая скорость считаются приемлемыми.",
            },
            {
                t: "Аудит камер",
                time: "3–5 дней",
                d: "Проверяем ракурс, разрешение, освещённость и RTSP-поток имеющихся камер. При необходимости рекомендуем изменить положение.",
            },
            {
                t: "Сбор и разметка данных",
                time: "2–3 недели",
                d: "Собираем видео с вашего объекта и размечаем кадры вручную. Этот этап самый долгий, но именно он определяет итоговую точность.",
            },
            {
                t: "Обучение модели",
                time: "1–3 недели",
                d: "Модель семейства YOLO обучается в PyTorch, затем переводится в ONNX или TensorRT для ускорения. Результат измеряется на тестовой выборке.",
            },
            {
                t: "Интеграция и установка",
                time: "2–4 недели",
                d: "Сервис ставится на сервер или edge-устройство вроде Jetson, подключаются каналы оповещений и API вашей системы.",
            },
            {
                t: "Опытная эксплуатация",
                time: "постоянно",
                d: "Первые 3–4 недели наблюдаем в реальных условиях: снижаем ложные срабатывания, настраиваем пороги и дообучаем модель на новых кадрах.",
            },
        ],
    },

    samples: {
        eyebrow: "Примеры",
        h: "Проекты, над которыми мы работали",
        sub: "Системы для производства, логистики и безопасности — от анализа процесса до запуска.",
        cta: "Все проекты",
        slugs: ["firewise", "suvmash-jsc", "logistatrans", "grandpharm"],
    },

    faq: {
        eyebrow: "Вопросы и ответы",
        h: "Частые вопросы",
        sub: "Короткие ответы на то, что спрашивают о компьютерном зрении чаще всего.",
        items: [
            {
                q: "Сколько стоит внедрение Computer Vision?",
                a: "Пилотный проект начинается от 45 000 000 сум: это полноценное решение для одной задачи и 1–3 камер. Полное внедрение на объекте, то есть 4–16 камер и несколько сценариев, — от 120 000 000 сум. Для сети филиалов или нестандартной модели цена определяется индивидуально. Стоимость камер и сервера в смету не входит.",
            },
            {
                q: "Какая будет точность в процентах?",
                a: "Точности 100% не бывает, и предложению с такой гарантией доверять не стоит. При хорошем освещении и правильном ракурсе распознавание номеров и подсчёт объектов обычно работают на 90–97%. В сложных условиях — темнота, дождь, перекрытие объектов — показатель падает до 75–90%. Точную цифру мы измеряем на тестовой выборке после пилота.",
            },
            {
                q: "Подойдут ли мои существующие камеры?",
                a: "Чаще всего да. Если камера отдаёт RTSP-поток и её разрешение не ниже 1080p, мы её используем. Проблема обычно не в камере, а в ракурсе: камера строго сверху не покажет лицо, а слишком удалённая не прочитает этикетку товара. На этапе аудита мы это выявляем и даём конкретные рекомендации.",
            },
            {
                q: "Сколько времени занимает проект?",
                a: "Пилот запускается за 6–8 недель, полное внедрение занимает 10–14 недель. Большая часть срока уходит на сбор и разметку данных — этот этап нельзя ускорить, потому что модель распознаёт только те ситуации, которые видела. Если у вас есть архив видео, срок сокращается на 1–2 недели.",
            },
            {
                q: "Будет ли система работать без интернета?",
                a: "Да, если решение установлено на edge-устройстве. Устройство вроде NVIDIA Jetson стоит рядом с камерой и выполняет анализ на месте, а интернет нужен только для отправки уведомлений. При обрыве связи события копятся в локальной базе и уходят на сервер после восстановления соединения.",
            },
            {
                q: "Где хранятся видеоданные?",
                a: "Это выбираете вы. По умолчанию видео целиком не хранится — записываются только кадр события и числовой результат, что снижает и объём, и риски. Если нужен закрытый контур, вся система работает на вашем сервере и ни один кадр наружу не уходит. Дополнительно можно включить автоматическое размытие лиц.",
            },
            {
                q: "Насколько надёжно распознавание лиц?",
                a: "При хорошем освещении и лице, обращённом к камере, сотрудники распознаются с точностью выше 95%. Но маска, солнцезащитные очки, боковой ракурс и темнота заметно снижают результат. Поэтому мы рекомендуем использовать распознавание лиц в контроле доступа не как единственный способ, а вместе с картой или PIN-кодом.",
            },
            {
                q: "Сколько камер можно подключить к одному серверу?",
                a: "Зависит от модели и требуемой скорости. Средний сервер с GPU обрабатывает 8–16 камер на скорости 5–10 кадров в секунду — для подсчёта и контроля безопасности этого достаточно. Для быстрого движения на конвейере на одну камеру нужно больше ресурсов. Точную спецификацию мы даём после разбора вашей задачи.",
            },
            {
                q: "Ухудшается ли модель со временем?",
                a: "Да, если меняются условия. Новый тип упаковки, сдвиг ракурса камеры, сезонное изменение освещения — всё это снижает точность. Поэтому в поддержку входит мониторинг качества: ошибки накапливаются, и один-два раза в год модель дообучается на новых кадрах. Такие работы мы планируем заранее, а не по факту жалоб.",
            },
            {
                q: "В каких случаях Computer Vision не нужен?",
                a: "Если задачу решает более простой способ. Когда на товаре есть штрих-код, сканер дешевле и точнее; для контроля доступа иногда достаточно карты и турникета. Также если событие происходит очень редко и проверить его вручную легко, проект может не окупиться. Мы говорим об этом прямо на консультации.",
            },
        ],
    },

    cta: {
        h: "Что именно должны показывать ваши камеры?",
        p: "На бесплатной консультации разберём вашу задачу, скажем, решается ли она компьютерным зрением и какая точность реалистична. Телефон: +998 90 954 12 62.",
        button: "Получить бесплатную консультацию",
        secondary: "Написать в Telegram",
    },

    images: [
        {
            src: "/assets/img/services/computer-vision-hero.webp",
            alt: "Система Computer Vision считает коробки на складе в реальном времени и обводит их рамками",
            caption: "Каждый объект в потоке камеры обводится рамкой и попадает в счётчик.",
            prompt: "Wide photorealistic shot of a modern warehouse aisle with stacked cardboard boxes on pallets. Overlaid on the image are clean neon-cyan bounding boxes around each box with small confidence labels like 0.94, plus a counter widget in the corner reading 'BOXES: 128'. Industrial lighting, slight depth of field, dark teal and graphite color grading, no visible faces, no text other than the overlay labels. 16:9.",
        },
        {
            src: "/assets/img/services/computer-vision-ppe.webp",
            alt: "Видеоаналитика контроля касок и сигнальных жилетов на строительной площадке",
            caption: "Рабочий без каски — и инженеру по охране труда сразу уходит кадр.",
            prompt: "Photorealistic construction site viewed from a fixed CCTV angle, several workers in helmets and high-visibility vests. Green bounding boxes labelled 'HELMET OK' around compliant workers and one amber box labelled 'NO HELMET' around a worker without one. Slight CCTV grain, timestamp in the top corner, muted daylight, faces blurred. 16:9.",
        },
        {
            src: "/assets/img/services/computer-vision-anpr.webp",
            alt: "Распознавание автомобильного номера на въезде парковки и автоматическое открытие шлагбаума",
            caption: "Номер читается за 1–2 секунды и сверяется со списком допуска.",
            prompt: "Night scene at a parking barrier entrance, a car approaching with headlights on. A crisp cyan rectangle highlights the license plate area with a readout panel beside it showing recognised characters and a green 'ACCESS GRANTED' state. Wet asphalt reflections, cinematic dark blue palette, plate characters are generic and unreadable as a real number. 16:9.",
        },
        {
            src: "/assets/img/services/computer-vision-quality.webp",
            alt: "Автоматический контроль качества продукции на конвейере с помощью computer vision",
            caption: "Бракованная единица помечается и попадает в статистику смены.",
            prompt: "Close-up of a factory conveyor belt carrying identical metal or plastic components under bright inspection lighting, with an industrial camera mounted above. Most parts are outlined in green, one is outlined in red with a small label 'DEFECT: SCRATCH'. Shallow depth of field, clean industrial aesthetic, cool white lighting, no people. 16:9.",
        },
        {
            src: "/assets/img/services/computer-vision-dashboard.webp",
            alt: "Панель аналитики Computer Vision: длина очереди, журнал событий и дневные графики",
            caption: "Данные с камер превращаются в дневные графики и журнал событий.",
            prompt: "Clean dark-themed analytics dashboard UI on a widescreen monitor: a live camera tile in the top left, a line chart of queue length by hour, a bar chart of detections per shift, and a scrollable event log with small thumbnail frames. Cyan and violet accents on a graphite background, generic placeholder labels, no real brand names, crisp UI rendering. 16:9.",
        },
    ],

    related: ["sun-iy-intellekt", "ai-integratsiya", "ai-agent", "biznes-avtomatlashtirish"],
};

const content = { uz, ru };

export default content;
